import { UserModel } from '../models/user.model';
export default class Auth {

  static getToken(): string {
    return atob(localStorage.getItem('token'));
  }

  static getUser(): UserModel {
    return JSON.parse(atob(localStorage.getItem('user')));
  }

  static userIsAuthenticated(): boolean {
    try {
      return Auth.getToken() !== undefined && Auth.getToken() !== '' && Auth.getUser() !== undefined && Auth.getUser().id !== '';
    } catch (err) {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/helpers/auth.ts